<template>
  <div class="details__info-block">
    <div class="row">
      <div class="col-12 col-lg-4">
        ФИО
      </div>
      <div class="custom-element">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserModalBodyItem',
  props: {
    text: { type: String },
  },
});
</script>
